(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('kendo.core.js'), require('kendo.drawing.cmn.chunk.js')) :
    typeof define === 'function' && define.amd ? define(['exports', 'kendo.core', 'kendo.drawing.cmn.chunk'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory((global.kendo = global.kendo || {}, global.kendo._globals = global.kendo._globals || {}, global.kendo._globals.Color = {}), global.kendo._globals.Core, global.kendo._globals.DrawingCmnChunk));
})(this, (function (exports, kendo_core_js, kendo_drawing_cmn_chunk_js) {
    const __meta__ = {
        id: "color",
        name: "Color utils",
        category: "framework",
        advanced: true,
        description: "Color utilities used across components",
        depends: ["core", "drawing.cmn.chunk"]
    };

    window.kendo = window.kendo || {};

    kendo.deepExtend(kendo, {
        parseColor: kendo_drawing_cmn_chunk_js.p,
        namedColors: kendo_drawing_cmn_chunk_js.Y,
        Color: kendo_drawing_cmn_chunk_js.C
    });

    exports.__meta__ = __meta__;

}));
